// extracted by mini-css-extract-plugin
export default {"shadow":"header_shadow__vKMqB","header":"header_header__ygEOz","border":"header_border__8mM0c"};